import React, { useState } from 'react';

import { useSnrwbCore } from '../../../../common/hooks/useSnrwbCore';
import { Filter, FilterReportData } from '../../../components/Reports/Filter';
import { ReportBySampleExam } from '../../../components/ReportBySampleExam/ReportBySampleExam';
import { ReportOrderedSampleExamsType } from '../../../../common/types/ReportTypes';
import abbreviationLegend from '../../../../common/abbreviationLegend';

export const ReportSampleExamAView: React.FC = () => {
  const snrwbApi = useSnrwbCore();
  const [filterApplied, setFilterApplied] = useState(false);
  const [usedFilter, setUsedFilter] = useState<FilterReportData | undefined>(
    {},
  );
  const [data, setData] = useState<ReportOrderedSampleExamsType>({
    details: {},
    sum: {},
  });

  const onSearch = (filter?: FilterReportData) => {
    setFilterApplied(true);
    setUsedFilter(filter);
    snrwbApi.reports
      .reportOrderedSampleExams(false, filter)
      .then(dataReports => {
        setData(dataReports);
      });
  };

  return (
    <>
      <Filter
        onSearch={onSearch}
        reportName="Badania próbek wyrobów budowlanych"
      />
      <ReportBySampleExam
        data={data}
        reportName="Zlecone badania próbek wyrobów budowlanych - bez badania próbek kontrolnych"
        filterApplied={filterApplied}
        usedFilter={usedFilter}
        legend={abbreviationLegend('samples', [
          '25.1',
          '16.2a',
          'Pp',
          'S',
          'B',
          'P',
          'N',
        ])}
      />
    </>
  );
};
